import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { feedbackActions as actions, notificationActions } from '../actions';
import { feedbackService } from '../services';

/* Create Feedback Team Sagas */
function* handleCreateFeedbackTeamRequest() {
    const action = yield take(actions.createFeedbackTeamRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(feedbackService.createFeedbackTeam, dataParams);
        if (res.isError) {
            yield put(actions.createFeedbackTeamError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.createFeedbackTeamSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.createFeedbackTeamError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Feedback Teams Sagas*/
function* handleGetAllFeedbackTeamsRequest() {
    const action = yield take(actions.getAllFeedbackTeamsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(feedbackService.getAllFeedbackTeams, dataParams);

        if (res.isError) {
            yield put(actions.getAllFeedbackTeamsError(res));

        } else {
            yield put(actions.getAllFeedbackTeamsSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllFeedbackTeamsError());
    }
}

/* Create Feedback Sagas*/
function* handleCreateFeedbackRequest() {
    const action = yield take(actions.createFeedbackRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(feedbackService.createFeedback, dataParams);

        if (res.isError) {
            yield put(actions.createFeedbackError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.createFeedbackSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.createFeedbackError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Given Feedback Sagas */
function* handleGivenFeedbackRequest() {
    const action = yield take(actions.givenFeedbackRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(feedbackService.givenFeedback, dataParams);
        if (res.isError) {
            yield put(actions.givenFeedbackError(res));
        } else {
            yield put(actions.givenFeedbackSuccess(res));
        }
    } catch (error) {
        yield put(actions.givenFeedbackError());
    }
}

/* Get Received Feedback On Filter Sagas*/
function* handleGetReceivedFeedbackOnFilterRequest() {
    const action = yield take(actions.getReceivedFeedbackOnFilterRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(feedbackService.getReceivedFeedbackOnFilter, dataParams);
        if (res.isError) {
            yield put(actions.getReceivedFeedbackOnFilterError(res));
        } else {
            yield put(actions.getReceivedFeedbackOnFilterSuccess(res));
        }
    } catch (error) {
        yield put(actions.getReceivedFeedbackOnFilterError());
    }
}

/* Get Feedback Dashboard Data Sagas*/
function* handleGetFeedbackDashboardDataRequest() {
    const action = yield take(actions.getFeedbackDashboardDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(feedbackService.getFeedbackDashboardData, dataParams);
        if (res.isError) {
            yield put(actions.getFeedbackDashboardDataError(res));
        } else {
            yield put(actions.getFeedbackDashboardDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getFeedbackDashboardDataError());
    }
}

/* -----------Watchers------------- */
function* handleCreateFeedbackTeamWatcher() {
    yield takeEvery(
        actions.createFeedbackRequest,
        handleCreateFeedbackTeamRequest,
    );
}

function* handleGetAllFeedbackTeamsWatcher() {
    yield takeEvery(
        actions.getAllFeedbackTeamsRequest,
        handleGetAllFeedbackTeamsRequest,
    );
}

function* handleCreateFeedbackWatcher() {
    yield takeEvery(
        actions.createFeedbackRequest,
        handleCreateFeedbackRequest,
    );
}

function* handleGivenFeedbackWatcher() {
    yield takeEvery(
        actions.givenFeedbackRequest,
        handleGivenFeedbackRequest,
    );
}

function* handleGetReceivedFeedbackOnFilterWatcher() {
    yield takeEvery(
        actions.getReceivedFeedbackOnFilterRequest,
        handleGetReceivedFeedbackOnFilterRequest,
    );
}

function* handleGetFeedbackDashboardDataWatcher() {
    yield takeEvery(
        actions.getFeedbackDashboardDataRequest,
        handleGetFeedbackDashboardDataRequest,
    );
}



function* rootFeedbackSaga() {
    yield all([
        handleCreateFeedbackTeamRequest(),
        handleCreateFeedbackTeamWatcher(),

        handleGetAllFeedbackTeamsRequest(),
        handleGetAllFeedbackTeamsWatcher(),

        handleCreateFeedbackRequest(),
        handleCreateFeedbackWatcher(),

        handleGivenFeedbackRequest(),
        handleGivenFeedbackWatcher(),

        handleGetReceivedFeedbackOnFilterRequest(),
        handleGetReceivedFeedbackOnFilterWatcher(),
        
        handleGetFeedbackDashboardDataRequest(),
        handleGetFeedbackDashboardDataWatcher(),
    ]);
}

export default rootFeedbackSaga;
